<template>
    <div>
        <el-checkbox-group v-model="checkedType" @change="checkedTypeChange" :loading="loading"
            :disabled="dataList.length === 0">
            <el-checkbox v-for="item in checkStatus" :key="item.label" :label="item.is_settle"
                :indeterminate="item.indeterminate">
                {{ item.label }}
            </el-checkbox>
        </el-checkbox-group>
        <slot name="content" />
    </div>
</template>
<script>
export default {
    name: 'SelectAll',
    props: {
        dataList: { type: Array, default() { return [] } }, // 列表数据
        loading: { type: Boolean, default: false }, // 加载状态
        selectedArr: { type: Array, default() { return [] } }, // 列表选中的数据
        handleChecked: { type: Function }, // 处理选中的数据
        isPrekeep: { type: Boolean, default: false }, // 是否保留上一次选中的数据
    },
    data() {
        return {
            checkedType: [],
            checkStatus: [
                { label: "本页选中", is_settle: 1, indeterminate: false },
                { label: "搜索结果全选", is_settle: 2, indeterminate: false },
            ]
        }
    },
    methods: {

        // 选择本页选中或搜索结果全选
        checkedTypeChange(val) {
            this.$nextTick(() => {
                const checkedType = val[val.length - 1]
                this.checkedType = val.length > 0 ? [checkedType] : []
                this.handleChecked && this.handleChecked(Boolean(checkedType), checkedType == 2)
            })
        },
    },
    watch: {
        selectedArr(newVal) {
            const checkedType = this.checkedType[this.checkedType.length - 1]
            if (checkedType != 2) {
                this.checkedType = []
                this.checkStatus.forEach(item => item.indeterminate = false)
                this.$nextTick(() => {
                    this.checkedType = (this.dataList.length > 0 && newVal.length == this.dataList.length) ? [1] : []
                    this.checkStatus[0].indeterminate = newVal.length > 0 && newVal.length != this.dataList.length
                })
            }
        },
        // 监听列表数据的变化，用于是否保留上一次选中的数据，传递第三个参数
        dataList() {
            const checkedType = this.checkedType[this.checkedType.length - 1]
            if (checkedType === 2 && this.isPrekeep) {
                this.$nextTick(() => {
                    this.handleChecked && this.handleChecked(Boolean(checkedType), checkedType == 2, this.isPrekeep)
                })
            }
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/SelectAll/index.vue